import React from 'react';
import { Grid, Typography, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import PidoImage from '../../assets/images/pido.png';
import useStyles from './styles';

function Payment() {
  let title = 'عملیات ناموفق';
  let message =
    'متأسفانه مشکلی در پرداختتان پیش آمده است. نگران نباشید، اگر وجهی از حسابتان کم شده است تا کمتر از ۷۲ ساعت دیگر به حسابتان برمی‌گردد.';

  const classes = useStyles();
  let { status, inctype } = useParams();
  status = status.replace('status=', '');
  if (inctype) inctype = inctype.replace('inctype=', '');
  else inctype = 'wallet';

  const getMessage = () => {
    if (status === '1') {
      title = 'عملیات موفق';
      message = 'افزایش موجودی کیف پول شما با موفقیت انجام گرفت.';
      if (inctype === 'najaPayment') message = 'پرداخت خلافی شما با موفقیت انجام گرفت';
    } else if (status === '3') {
      message =
        'کاربر گرامی تراکنش شما توسط بانک انجام گردیده است.متاسفانه ما نتوانستیم کیف پول شما را افزایش دهیم،لطفا با پشتیبانی تماس بگیرید.';
    }
  };
  getMessage();

  return (
    <React.Fragment>
      <Grid>
        <Grid className={classes.gridImage}>
          <img src={PidoImage} alt={'pido'} className={classes.image} />
        </Grid>
        <Grid className={classes.content}>
          <Grid className={status === '1' ? classes.title_success : classes.title_error}>
            <Typography fontSize={25} fontWeight={450}>
              {title}
            </Typography>
          </Grid>
          <Grid className={classes.message}>
            <Typography fontSize={17}>{message}</Typography>
          </Grid>
          <Button
            href={
              'https://app.pido.co.ir/payment-result/status=' +
              status +
              '/inctype=' +
              inctype
            }
            variant="contained"
          >
            {'بازگشت به اپلیکیشن'}
          </Button>
          <br />
          <Button color="secondary" variant="outlined" href="tel:02191076222">
            {'تماس با پشتیبانی'}
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default Payment;
